import store from '@/store'
import request from 'utils/request'

// 前端登录后缓存的数据刷新工具
// 说明：
// 1. 字典(dicts)、菜单动态路由(USER_ROUTER)、当前用户资料(user) 均可通过接口独立刷新；
// 2. 权限(permissions)、角色(roles) 目前仅在登录接口(login)一次性返回，
//    后端未提供单独获取当前用户权限/角色的接口，故无法在此单独刷新，需重新登录后才会更新。

// 获取当前登录用户名
function currentUsername () {
  const user = store.state.account.user
  return user && user.username ? user.username : ''
}

// 刷新字典缓存：dict/trim -> dict/setDicts
export function refreshDicts () {
  return request.get('dict/trim').then((r) => {
    store.commit('dict/setDicts', r.data)
  })
}

// 刷新当前用户资料：user/{username} -> account/setUser
export function refreshCurrentUser () {
  const username = currentUsername()
  if (!username) return Promise.resolve()
  return request.get(`user/${username}`).then((r) => {
    store.commit('account/setUser', r.data)
  })
}

// 刷新菜单动态路由：menu/{username} -> localStorage.USER_ROUTER
// 保存后端返回的原始路由数据，页面 reload 后由路由守卫(router/index.js)重建动态路由
export function refreshMenu () {
  const username = currentUsername()
  if (!username) return Promise.resolve()
  return request.get(`menu/${username}`).then((r) => {
    localStorage.setItem('USER_ROUTER', JSON.stringify(r.data))
  })
}

// 刷新全部可刷新的前端缓存：字典 + 当前用户资料 + 菜单
// 返回 Promise，调用方可在成功后决定是否 reload 页面使菜单/路由生效
export function refreshCache () {
  return Promise.all([
    refreshDicts(),
    refreshCurrentUser(),
    refreshMenu()
  ])
}

export default refreshCache



// WEBPACK FOOTER //
// ./src/utils/refreshCache.js